import React from 'react'

const Notes = () => {
    return (
        <div className="p-4">Notes Content</div>
    )
}

export default Notes
